/**
 * Rocksoft Places API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CheckInCommand } from '../model/checkInCommand';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface CheckInByIdRequestParams {
    /** The room ID. */
    roomCategoryId: string;
    /** The check-in command. */
    checkInCommand?: CheckInCommand;
}

export interface CheckOutByIdRequestParams {
    /** The persistent room ID. */
    roomCategoryId: string;
}

export interface MoveReservationRequestParams {
    /** The persistent room ID to move from. */
    roomCategoryId: string;
    /** The persistent room ID to move to. */
    toRoomCategoryId: string;
}


@Injectable({
  providedIn: 'root'
})
export class RoomStatusService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Check-In a room.
     * @endpoint post /rooms/{roomCategoryId}/checkin
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public checkInById(requestParameters: CheckInByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public checkInById(requestParameters: CheckInByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public checkInById(requestParameters: CheckInByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public checkInById(requestParameters: CheckInByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const roomCategoryId = requestParameters?.roomCategoryId;
        if (roomCategoryId === null || roomCategoryId === undefined) {
            throw new Error('Required parameter roomCategoryId was null or undefined when calling checkInById.');
        }
        const checkInCommand = requestParameters?.checkInCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;odata.metadata=minimal;odata.streaming=true',
            'application/json;odata.metadata=minimal;odata.streaming=false',
            'application/json;odata.metadata=minimal',
            'application/json;odata.metadata=full;odata.streaming=true',
            'application/json;odata.metadata=full;odata.streaming=false',
            'application/json;odata.metadata=full',
            'application/json;odata.metadata=none;odata.streaming=true',
            'application/json;odata.metadata=none;odata.streaming=false',
            'application/json;odata.metadata=none',
            'application/json;odata.streaming=true',
            'application/json;odata.streaming=false',
            'application/json',
            'application/json;odata.metadata=minimal;odata.streaming=true;IEEE754Compatible=false',
            'application/json;odata.metadata=minimal;odata.streaming=true;IEEE754Compatible=true',
            'application/json;odata.metadata=minimal;odata.streaming=false;IEEE754Compatible=false',
            'application/json;odata.metadata=minimal;odata.streaming=false;IEEE754Compatible=true',
            'application/json;odata.metadata=minimal;IEEE754Compatible=false',
            'application/json;odata.metadata=minimal;IEEE754Compatible=true',
            'application/json;odata.metadata=full;odata.streaming=true;IEEE754Compatible=false',
            'application/json;odata.metadata=full;odata.streaming=true;IEEE754Compatible=true',
            'application/json;odata.metadata=full;odata.streaming=false;IEEE754Compatible=false',
            'application/json;odata.metadata=full;odata.streaming=false;IEEE754Compatible=true',
            'application/json;odata.metadata=full;IEEE754Compatible=false',
            'application/json;odata.metadata=full;IEEE754Compatible=true',
            'application/json;odata.metadata=none;odata.streaming=true;IEEE754Compatible=false',
            'application/json;odata.metadata=none;odata.streaming=true;IEEE754Compatible=true',
            'application/json;odata.metadata=none;odata.streaming=false;IEEE754Compatible=true',
            'application/json;odata.metadata=none;odata.streaming=false;IEEE754Compatible=false',
            'application/json;odata.metadata=none;IEEE754Compatible=false',
            'application/json;odata.metadata=none;IEEE754Compatible=true',
            'application/json;odata.streaming=true;IEEE754Compatible=false',
            'application/json;odata.streaming=true;IEEE754Compatible=true',
            'application/json;odata.streaming=false;IEEE754Compatible=false',
            'application/json;odata.streaming=false;IEEE754Compatible=true',
            'application/json;IEEE754Compatible=false',
            'application/json;IEEE754Compatible=true',
            'application/xml',
            'text/plain',
            'application/json-patch+json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rooms/${this.configuration.encodeParam({name: "roomCategoryId", value: roomCategoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checkin`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checkInCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Check-Out a room.
     * @endpoint post /rooms/{roomCategoryId}/checkout
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public checkOutById(requestParameters: CheckOutByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public checkOutById(requestParameters: CheckOutByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public checkOutById(requestParameters: CheckOutByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public checkOutById(requestParameters: CheckOutByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const roomCategoryId = requestParameters?.roomCategoryId;
        if (roomCategoryId === null || roomCategoryId === undefined) {
            throw new Error('Required parameter roomCategoryId was null or undefined when calling checkOutById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rooms/${this.configuration.encodeParam({name: "roomCategoryId", value: roomCategoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/checkout`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move a reservation from one room to another.
     * @endpoint post /rooms/{roomCategoryId}/move-reservation/{toRoomCategoryId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public moveReservation(requestParameters: MoveReservationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public moveReservation(requestParameters: MoveReservationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public moveReservation(requestParameters: MoveReservationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public moveReservation(requestParameters: MoveReservationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const roomCategoryId = requestParameters?.roomCategoryId;
        if (roomCategoryId === null || roomCategoryId === undefined) {
            throw new Error('Required parameter roomCategoryId was null or undefined when calling moveReservation.');
        }
        const toRoomCategoryId = requestParameters?.toRoomCategoryId;
        if (toRoomCategoryId === null || toRoomCategoryId === undefined) {
            throw new Error('Required parameter toRoomCategoryId was null or undefined when calling moveReservation.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rooms/${this.configuration.encodeParam({name: "roomCategoryId", value: roomCategoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/move-reservation/${this.configuration.encodeParam({name: "toRoomCategoryId", value: toRoomCategoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
